










import { Vue, Component } from 'vue-property-decorator';
import AsignacionClienteGps from '@/pantallas/AsignacionClienteGps/AsignacionClienteGps.vue';

@Component({
  components: { AsignacionClienteGps },
})
export default class AsignacionClienteGpsPantalla extends Vue {}
